/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * From CIFTools.js
 * @author David Sehnal <david.sehnal@gmail.com>
 */
export var VERSION = '0.3.0';
export var Encoding;

(function (Encoding) {
  function getDataType(data) {
    var srcType;
    if (data instanceof Int8Array) srcType = 1
    /* Int8 */
    ;else if (data instanceof Int16Array) srcType = 2
    /* Int16 */
    ;else if (data instanceof Int32Array) srcType = 3
    /* Int32 */
    ;else if (data instanceof Uint8Array) srcType = 4
    /* Uint8 */
    ;else if (data instanceof Uint16Array) srcType = 5
    /* Uint16 */
    ;else if (data instanceof Uint32Array) srcType = 6
    /* Uint32 */
    ;else if (data instanceof Float32Array) srcType = 32
    /* Float32 */
    ;else if (data instanceof Float64Array) srcType = 33
    /* Float64 */
    ;else srcType = 3
    /* Int32 */
    ; // throw new Error('Unsupported integer data type.');

    return srcType;
  }

  Encoding.getDataType = getDataType;

  function isSignedIntegerDataType(data) {
    if (data instanceof Int8Array || data instanceof Int16Array || data instanceof Int32Array) return true;

    for (var i = 0, _i = data.length; i < _i; i++) {
      if (i < 0) return false;
    }

    return true;
  }

  Encoding.isSignedIntegerDataType = isSignedIntegerDataType;
})(Encoding || (Encoding = {}));